import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

/* SVGR has dropped some elements not supported by react-native-svg: filter */

function ZetCoin({ size, ...props }: { size?: number }) {
  return (
    <Svg
      width={size || 49}
      height={size || 49}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1022_45813)">
        <Path
          d="M48.148 24.703c0 13.255-10.745 24-24 24-6.987 0-13.277-2.986-17.663-7.751a24.101 24.101 0 01-3.04-4.1A23.894 23.894 0 01.149 24.703c0-13.255 10.746-24 24-24a23.88 23.88 0 0112.15 3.298 23.99 23.99 0 014.098 3.04 23.93 23.93 0 017.752 17.662z"
          fill="#F0CD00"
        />
        <Path
          d="M48.149 24.703c0 12.956-10.265 23.514-23.107 23.983C12.201 48.217 1.936 37.66 1.936 24.703 1.936 11.747 12.2 1.19 25.042.72c12.842.469 23.107 11.027 23.107 23.983z"
          fill="#FFDE50"
        />
        <Path
          d="M40.395 7.041l-33.91 33.91a24.105 24.105 0 01-3.04-4.099l32.852-32.85a23.99 23.99 0 014.099 3.04zM46.493 15.929l-31.12 31.12a23.967 23.967 0 01-6.076-3.492L43.003 9.852a23.928 23.928 0 013.49 6.077z"
          fill="#FFEA94"
        />
        <Path
          d="M42.798 24.703c0 10.3-8.35 18.65-18.65 18.65a18.56 18.56 0 01-9.78-2.769 18.7 18.7 0 01-5.466-5.138 18.562 18.562 0 01-3.401-10.514c-.002-.076-.002-.152-.002-.229 0-10.3 8.35-18.65 18.65-18.65a18.58 18.58 0 0113.186 5.462 18.662 18.662 0 012.695 3.407 18.558 18.558 0 012.768 9.781z"
          fill="#FAA300"
        />
        <Path
          d="M37.335 11.516L10.96 37.889a18.684 18.684 0 01-4.165-6.34 18.562 18.562 0 01-1.295-6.617c-.002-.076-.002-.152-.002-.229 0-10.3 8.35-18.65 18.65-18.65a18.58 18.58 0 0113.186 5.462z"
          fill="#FFBD00"
        />
        <Path
          d="M42.797 24.703c0 10.3-8.35 18.65-18.65 18.65-.353 0-.703-.01-1.052-.03 9.81-.545 17.595-8.674 17.595-18.62 0-9.946-7.786-18.074-17.595-18.62.349-.02.7-.03 1.053-.03 10.3 0 18.65 8.35 18.65 18.65z"
          fill="#F68E00"
        />
        <G filter="url(#filter0_d_1022_45813)" fill="#fff">
          <Path d="M38.475 18.779h-12.93l1.662 3.647h3.825v8.2h3.651v-8.2h3.792V18.78zM18.928 18.779H8.488v3.647h5.035L8.488 26.98v3.648h10.44v-3.648h-5.034l5.034-4.553V18.78zM28.429 26.98h-5.322v-.629h5.026l-.949-2.052-.578-1.245h-3.5v-.628h3.176L24.62 18.78h-4.856V30.627h10.359l-1.694-3.648z" />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_1022_45813">
          <Path
            fill="#fff"
            transform="translate(.148 .703)"
            d="M0 0H48V48H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default ZetCoin
